'use client';

import { useTheme } from '@enlighten/design-system/dist/styles';
import dayjs from 'dayjs';
import * as echarts from 'echarts/core';
import EChartsReact from 'echarts-for-react';

import { fonts } from '@/styles/fonts';

export interface ChartProps {
	data: {
		date: string;
		amount: string;
	}[];
}

export default function Chart({ data }: ChartProps) {
	const theme = useTheme();

	return (
		<EChartsReact
			style={{ width: '100%', height: 160 }}
			option={{
				tooltip: {
					position(point: [number, number], _params: unknown, _dom: unknown, _rect: unknown, size: { contentSize: [number, number]; viewSize: [number, number] }) {
						const { contentSize, viewSize } = size;
						const x = point[0] + contentSize[0] > viewSize[0] ? viewSize[0] - contentSize[0] : point[0];
						return [x, point[1]];
					},
					formatter: '{c0} kWh',
					triggerOn: 'mousemove|click',
					backgroundColor: '#8131E8CC',
					borderWidth: 0,
					textStyle: {
						color: 'white',
						fontWeight: 'bold',
					},
				},
				xAxis: [
					{
						type: 'category',
						name: '일',
						nameTextStyle: {
							align: 'right',
							fontSize: 12,
							fontFamily: fonts.style.fontFamily,
							color: theme.palette.grey['600'],
						},
						splitLine: {
							show: false,
						},
						axisLabel: {
							color: theme.palette.grey['600'],
							fontSize: 12,
							fontFamily: fonts.style.fontFamily,
							margin: 12,
						},
						axisLine: {
							lineStyle: {
								color: theme.palette.grey['600'],
							},
						},
						axisTick: {
							show: false,
						},
						data: data.map((item) => dayjs(item.date.replace(/\./g, '')).format('D')),
					},
				],
				grid: {
					top: 30,
					right: 20,
					bottom: 30,
					left: 20,
				},
				yAxis: [
					{
						type: 'value',
						name: 'kWh',
						nameTextStyle: {
							align: 'center',
							fontSize: 12,
							fontFamily: fonts.style.fontFamily,
							color: theme.palette.grey['600'],
						},
						axisLabel: {
							color: theme.palette.grey['600'],
							fontSize: 12,
							fontFamily: fonts.style.fontFamily,
						},
						splitLine: {
							lineStyle: {
								color: theme.palette.grey['100'],
							},
						},
						splitNumber: 3,
					},
				],
				series: [
					{
						type: 'bar',
						data: data.map((item) => +(+item.amount.replace(/,/g, '')).toFixed(1)),
						itemStyle: {
							borderRadius: [2, 2, 0, 0],
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: theme.palette.primary.main },
								{ offset: 1, color: theme.palette.primary.light },
							]),
						},
					},
				],
			}}
		/>
	);
}
